module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_en-d23ca32e53c6fbd0e324e1591c47a5a8.png";